module.exports = __webpack_public_path__ + "img/compact.3aee364f.png";